import { render } from "./DetailComponent5Update.vue?vue&type=template&id=40a56ddc&scoped=true"
import script from "./DetailComponent5Update.vue?vue&type=script&lang=js"
export * from "./DetailComponent5Update.vue?vue&type=script&lang=js"

import "./DetailComponent5Update.vue?vue&type=style&index=0&id=40a56ddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a56ddc"]])

export default __exports__